import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, "Der Rechnungsempfänger", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_form_item = _resolveComponent("n-form-item")!

  return (_openBlock(), _createBlock(_component_n_form_item, {
    path: `person_id`,
    "show-feedback": false,
    rule: {
      type: 'number',
      required: true,
      trigger: ['blur', 'change'],
    }
  }, {
    label: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_component_n_select, {
        value: _ctx.localValue,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue) = $event)),
        options: _ctx.inhabitantsOptions,
        size: "large",
        class: "w-full"
      }, null, 8, ["value", "options"])
    ]),
    _: 1
  }))
}